import React, { useState, useEffect } from "react";
import TextareaAutosize from "react-textarea-autosize";
import { Link } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import ApiCaller from "api/apiCaller";
import Loading from "components/Loading";
import Constant from "constants";
import style from "react-syntax-highlighter/dist/esm/styles/hljs/agate";
import Select from "react-select";

import "./index.css";
import api from "api";
import { SelectOption, ApiResponse } from "model/response";
import { DataSource, DatasourceDetailResponse } from "model/datasource";
import {
  DataSourceType,
  DatasourceTypeListingResponse,
} from "model/datasource_type";

export default function DatasourceEdit(props: any) {
  const match = useRouteMatch("/datasource/:datasource_id");
  const params: any = match?.params;
  const datasourceId = params?.datasource_id;
  const [loading, setLoading] = useState(true);

  const isEdit = datasourceId ? true : false;
  const companyId: any = api.getCurrentCompanyId();
  const [currentUser, setCurrentUser] = useState<any>({});

  const BigQuery_DataSource_Type = 'google_bigquery';
  const MongoDB_DataSource_Type = 'mongo';
  const Telegram_DataSource_Type = 'alert_telegram';
  const Rdbms_Datasource_Type_Prefix = 'rdbms';
  const Email_Datasource_Type = 'email';

  const [SrvRecord, setSrvRecord] = useState<boolean>(false);
  const [datasourceTypeOptions, setDatasourceTypeOptions] = useState<Array<SelectOption>>([]);
  const [selectedDatasourceType, setSelectedDatasourceType] = useState<SelectOption | null>();

  const [datasourceData, setDatasourceData] = useState<DataSource>({
    name: "",
    datasource_type_id: 0,
    datasource_type_code_name: "",
    datasource_type_name: "",
    description: "",
    datasource_host: "",
    datasource_port: "",
    datasource_secret: "",
    datasource_secret_raw: "",
    datasource_username: "",
    datasource_password: "",
    datasource_database: "",
    extra_config: {},
    company_id: companyId,
  });

  useEffect(() => {
    initData();
  }, []);

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
    const res: ApiResponse = await ApiCaller.get(`datasource_type?is_active=1`);
    if (res?.status === "ok") {
      const data: DatasourceTypeListingResponse = res?.data;
      setDatasourceTypeOptions(
        data?.datasource_types?.map((datasource_type) => {
          return {
            label: `${datasource_type?.name}`,
            value: datasource_type.id,
            code_name: datasource_type.code_name
          };
        })
      );
      if (isEdit) {
        const resDatasourceDetail: ApiResponse = await ApiCaller.get(
          `datasource/${datasourceId}`
        );
        if (resDatasourceDetail?.status === "ok") {
          const dataDatasourceDetail: DatasourceDetailResponse =
            resDatasourceDetail?.data;
          // Find datasource type
          const findDatasourceType: any = data?.datasource_types.find(
            (datasource_type) => datasource_type.id == dataDatasourceDetail?.datasource?.datasource_type_id
          );

          setSelectedDatasourceType({
            label: `${findDatasourceType?.name}`,
            value: findDatasourceType?.id,
          });
          setDatasourceData({
            name: dataDatasourceDetail?.datasource?.name,
            datasource_type_id: dataDatasourceDetail?.datasource?.datasource_type_id,
            datasource_type_name: dataDatasourceDetail?.datasource?.datasource_type_name,
            datasource_type_code_name: dataDatasourceDetail?.datasource?.datasource_type?.code_name || "",
            description: dataDatasourceDetail?.datasource?.description,
            datasource_host: dataDatasourceDetail?.datasource?.datasource_host,
            datasource_port: dataDatasourceDetail?.datasource?.datasource_port,
            datasource_username: dataDatasourceDetail?.datasource?.datasource_username,
            datasource_password: dataDatasourceDetail?.datasource?.datasource_password,
            datasource_database: dataDatasourceDetail?.datasource?.datasource_database,
            datasource_secret: dataDatasourceDetail?.datasource?.datasource_secret,
            datasource_secret_raw: dataDatasourceDetail?.datasource?.datasource_secret_raw,
            company_id: dataDatasourceDetail?.datasource?.company_id,
            default_region_name: dataDatasourceDetail?.datasource?.default_region_name,
            extra_config: dataDatasourceDetail?.datasource?.extra_config
          });
          if (dataDatasourceDetail?.datasource?.extra_config) {
            if ('srv_record' in dataDatasourceDetail?.datasource?.extra_config) {
              setSrvRecord(dataDatasourceDetail?.datasource?.extra_config['srv_record'])
            }
          }
        }
      }
    }
    setLoading(false)
  };

  const onSubmit = async () => {
    setLoading(true);
    if (isEdit) {
      // Set schedule id to update
      const res: ApiResponse = await ApiCaller.put(
        `datasource/${datasourceId}`,
        datasourceData
      );
      if (res?.status === "ok") {
        setLoading(false);
        props.history.goBack();
        // window.location.href = `/schedule_query/${scheduleQueryId}/`;
      } else {
        setLoading(false);
        alert(res.message);
      }
    } else {
      const res: ApiResponse = await ApiCaller.post(
        `datasource`,
        datasourceData
      );
      if (res?.status === "ok") {
        // setLoading(false);
        props.history.goBack();
      } else {
        setLoading(false);
        alert(res.message);
      }
    }
  };

  if (loading) return <Loading />;

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <FormGroup>
            <Label for="project"> Datasource Type </Label>
            <Select
              placeholder=""
              options={datasourceTypeOptions}
              value={selectedDatasourceType}
              onChange={(selectedOption: any) => {
                setSelectedDatasourceType(selectedOption);
                setDatasourceData({
                  ...datasourceData,
                  ...{ datasource_type_id: selectedOption?.value },
                  ...{ datasource_type_code_name: selectedOption?.code_name }
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup className='required-field'>
            <Label>Name</Label>
            <Input
              type="text"
              value={datasourceData?.name}
              onChange={(e) => {
                setDatasourceData({
                  ...datasourceData,
                  ...{ name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        {datasourceData.datasource_type_code_name === MongoDB_DataSource_Type &&
          <Col xs={12}>
            <FormGroup>
              <Label>SRV record</Label> {' '}
              <input
                type="checkbox"
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ extra_config: {srv_record: e.target.checked}}
                  });
                  setSrvRecord(!SrvRecord)
                }}
                checked={SrvRecord}
              />
            </FormGroup>
          </Col>
        }
        {datasourceData.datasource_type_code_name !== BigQuery_DataSource_Type &&
          <Col xs={12}>
            <FormGroup className='required-field'>
              {datasourceData.datasource_type_code_name === Telegram_DataSource_Type ?
                <Label>Chat Id</Label> : <Label>Host</Label>
              }
              <Input
                required
                type="text"
                value={datasourceData?.datasource_host}
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ datasource_host: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        {(datasourceData.datasource_type_code_name.includes(Rdbms_Datasource_Type_Prefix) ||
          datasourceData.datasource_type_code_name === MongoDB_DataSource_Type) &&
          <Col xs={12}>
            <FormGroup className='required-field'>
              <Label>Port</Label>
              <Input
                required
                type="text"
                value={datasourceData?.datasource_port}
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ datasource_port: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        {(datasourceData.datasource_type_code_name.includes(Rdbms_Datasource_Type_Prefix) ||
          datasourceData.datasource_type_code_name === MongoDB_DataSource_Type ||
          datasourceData.datasource_type_code_name === Email_Datasource_Type) &&
          <Col xs={12}>
            <FormGroup className='required-field'>
              <Label>Username</Label>
              <Input
                type="text"
                value={datasourceData?.datasource_username}
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ datasource_username: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        {datasourceData.datasource_type_code_name !== BigQuery_DataSource_Type &&
          <Col xs={12}>
            <FormGroup className='required-field'>
              {datasourceData.datasource_type_code_name === Telegram_DataSource_Type ?
                <Label>Token</Label> : <Label>Password</Label>
              }
              <Input
                type="text"
                value={datasourceData?.datasource_password}
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ datasource_password: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        {(datasourceData.datasource_type_code_name.includes(Rdbms_Datasource_Type_Prefix) ||
          datasourceData.datasource_type_code_name === MongoDB_DataSource_Type) &&
          <Col xs={12}>
            <FormGroup className='required-field'>
              {datasourceData.datasource_type_code_name === MongoDB_DataSource_Type ?
                <Label>Authentication Database</Label> :
                <Label>Datasource Database</Label>
              }
              <Input
                required
                type="text"
                value={datasourceData?.datasource_database}
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ datasource_database: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        {/* {datasourceData.datasource_type_code_name === BigQuery_DataSource_Type &&
          <Col xs={12}>
            <FormGroup>
              <Label>Datasource Secret (Depreciate Soon)</Label>
              <Input
                type="text"
                value={datasourceData?.datasource_secret}
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ datasource_secret: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        } */}
        {datasourceData.datasource_type_code_name === BigQuery_DataSource_Type &&
          <Col xs={12}>
            <FormGroup className='required-field'>
              <Label>Datasource Secret Content</Label>
              <TextareaAutosize
                className="form-control"
                value={datasourceData?.datasource_secret_raw}
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ datasource_secret_raw: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        {datasourceData.datasource_type_code_name === BigQuery_DataSource_Type &&
          <Col xs={12}>
            <FormGroup>
              <Label>Default Region</Label>
              <Input
                type="text"
                value={datasourceData?.default_region_name}
                onChange={(e) => {
                  setDatasourceData({
                    ...datasourceData,
                    ...{ default_region_name: e.target.value },
                  });
                }}
              />
            </FormGroup>
          </Col>
        }
        <Col xs={12}>
          <FormGroup>
            <Label>Description</Label>
            <Input
              type="textarea"
              value={datasourceData?.description}
              onChange={(e) => {
                setDatasourceData({
                  ...datasourceData,
                  ...{ description: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div style={styles.controls}>
            <Button color="primary" onClick={onSubmit}>
              {isEdit ? "Save changes" : "Create"}
            </Button>{" "}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  controls: {
    marginTop: 12,
    marginBottom: 12,
  },
  info: {
    marginTop: 12,
    marginBottom: 12,
  },
  infoHeading: {
    fontWeight: 700,
  },
  queryContainer: {
    marginTop: 12,
  },
};
